import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import AboutBanner from '../../components/pages/About/AboutBanner/AboutBanner'
import GettingStarted from '../../components/pages/About/GettingStarted/GettingStarted'
import BluePrint from '../../components/pages/About/BluePrint/BluePrint'
import CEO from '../../components/pages/About/CEO/CEO.jsx'
import WhyUs from '../../components/pages/Home/WhyUs/WhyUs.jsx'
import ExtraOrdinary from '../../components/pages/Services/ExtraOrdinary/ExtraOrdinary.jsx'
import { AboutPageProvider } from '../../context/AboutPageContext'

const About = () => {
  return (
    <AboutPageProvider>
      <div>
        <Navbar />
        <AboutBanner />
        <GettingStarted />
        <BluePrint />
        <CEO />
        <WhyUs />
        <ExtraOrdinary />
        <Footer />
      </div>
    </AboutPageProvider>
  )
}

export default About
